import { Typography } from '@material-ui/core';
import React from 'react';

const TypeLabel = ({ children, classes }) => (
  <Typography className={classes.typeName}>{children}</Typography>
);

export default TypeLabel;
